import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_FEMALE_HOME = { announced: false, accepting: false, location: "", opening_date: "", note: "" };

export function femaleHomeStatus(fh) {
  if (fh.accepting) return { label: "Now Accepting Residents", tone: "live" };
  if (fh.announced && fh.opening_date) return { label: `Opening ${fh.opening_date}`, tone: "announced" };
  if (fh.announced) return { label: "Location Announced", tone: "announced" };
  return { label: "Coming Soon", tone: "soon" };
}

export function useFemaleHome() {
  const [fh, setFh] = useState(DEFAULT_FEMALE_HOME);
  useEffect(() => {
    fetch(`${API}/settings/female-home`)
      .then((r) => (r.ok ? r.json() : DEFAULT_FEMALE_HOME))
      .then(setFh)
      .catch(() => {});
  }, []);
  return fh;
}
